import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-content-between align-items-center m-2 bg-grey" }
const _hoisted_2 = { class: "flex flex-row align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pi pi-circle-fill text-xs mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "Theme:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PSelectButton = _resolveComponent("PSelectButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_PSelectButton, {
        allowEmpty: false,
        options: _ctx.options,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.save())),
        "aria-labelledby": "basic",
        modelValue: _ctx.option,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.option) = $event))
      }, null, 8, ["options", "modelValue"])
    ])
  ]))
}